function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.31818 0.5H3.36364C1.78727 0.5 0.5 1.78727 0.5 3.36364V18.6364C0.5 20.2127 1.78727 21.5 3.36364 21.5H18.6364C20.2127 21.5 21.5 20.2127 21.5 18.6364V17.6818V15.7727V3.36364C21.5 1.78727 20.2127 0.5 18.6364 0.5H6.22727H4.31818ZM19.5909 18.6364C19.5909 19.16 19.16 19.5909 18.6364 19.5909H3.36364C2.84 19.5909 2.40909 19.16 2.40909 18.6364V3.36364C2.40909 2.84 2.84 2.40909 3.36364 2.40909H18.6364C19.16 2.40909 19.5909 2.84 19.5909 3.36364V18.6364Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M4.79836 7.0509H17.2074C17.4693 7.0509 17.6875 6.83817 17.6875 6.5709V5.61635C17.6875 5.35453 17.4747 5.13635 17.2074 5.13635H4.79836C4.53654 5.13635 4.31836 5.34908 4.31836 5.61635V6.5709C4.31836 6.83817 4.53109 7.0509 4.79836 7.0509Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M4.79836 11.6873H17.2074C17.4693 11.6873 17.6875 11.4745 17.6875 11.2073V10.2527C17.6875 9.99089 17.4747 9.77271 17.2074 9.77271H4.79836C4.53654 9.77271 4.31836 9.98543 4.31836 10.2527V11.2073C4.31836 11.4745 4.53109 11.6873 4.79836 11.6873Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.79836 16.3182H17.2074C17.4693 16.3182 17.6875 16.1055 17.6875 15.8382V14.8837C17.6875 14.6219 17.4747 14.4037 17.2074 14.4037H4.79836C4.53654 14.4037 4.31836 14.6164 4.31836 14.8837V15.8382C4.31836 16.1055 4.53109 16.3182 4.79836 16.3182Z"
});

var SvgOrdersIcon = function SvgOrdersIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrdersIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/orders-icon.8fe24812.svg";
export { ForwardRef as ReactComponent };